import { Box, Flex, HStack } from '@chakra-ui/react';
import React from 'react';
import { BsBriefcase, BsGraphUp, BsNewspaper, BsPerson } from 'react-icons/bs';
import { OverviewConversion } from '../../components/overview/Conversion';
import OverviewHeader from '../../components/overview/Header';
import ProgressStat from '../../components/overview/ProgressStat';
import OverviewTasks from '../../components/overview/Tasks';
import OverviewTimeline from '../../components/overview/Timeline';
import OverviewUpdates from '../../components/overview/Updates';
import { WebsiteVisits } from '../../components/overview/WebsiteVisits';
import { ProgressStatProps } from '../../types/ui';
import { overviewItemsList } from '../../utilities/dummy';

export default function Overview() {
    const progressReports: ProgressStatProps[] = [
        { id: '1', amount: '90,292.56', subTitle: 'Deals closed', icon: BsBriefcase, currency: '$', currentRate: 20, barColour: 'pink' },
        { id: '2', amount: '280.56', subTitle: 'New users', icon: BsPerson, currentRate: 70, barColour: 'blue' },
        { id: '3', amount: '280.56', subTitle: 'Lead conversions', icon: BsGraphUp, currentRate: 10, barColour: 'green' },
        { id: '4', amount: '2,880.56', subTitle: 'Sent campaigns', icon: BsNewspaper, currentRate: 50, barColour: 'teal' },
    ]

    return (
        <Box paddingX='8' paddingBottom='4' paddingTop='0' width='100%'>
            <Box>
                <OverviewHeader username='Keith & Sons' overviewItemsList={overviewItemsList} />
            </Box>
            {/* First section */}
            <HStack spacing='8px' width='100%' marginTop={'8'}>
                {progressReports.map((item, index) => (
                    <ProgressStat key={index} {...item} />
                ))}
            </HStack>
            
            {/* Third section */}
            <Flex width='100%' marginTop='8' alignItems={'flex-start'}>
                <OverviewConversion />
                <Flex width='35%' justifyContent='center' direction={'column'}>
                    <OverviewTasks />
                    <WebsiteVisits />
                </Flex>
            </Flex>

            {/* Last section */}
            <Flex marginTop={'8'}>
                <OverviewUpdates />
                <OverviewTimeline />
            </Flex>
        </Box>
    )
}